import { Link } from 'react-router-dom';
import useSEO from '../hooks/useSEO';

export default function About() {
  // SEO metadata
  useSEO({
    title: 'About Us - Magnolia Mold Co',
    description: 'Meet Victoria, the creator behind Magnolia Mold Co. Learn about our story, our passion for handcrafted polymer clay earrings, and our commitment to quality.',
    url: 'https://magnoliamoldco.com/about',
    keywords: 'about magnolia mold, handmade earrings maker, victoria polymer clay artist, small business story'
  });

  const specials = [
    'Handcrafted with care and attention to detail',
    "Unique designs you won't find anywhere else",
    'High-quality materials',
    'Affordable prices',
  ];

  return (
    <div>
      {/* Page header */}
      <div className="bg-cream-50 border-b border-cream-300">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16 text-center">
          <img src="/logo.png" alt="" className="h-16 w-auto mx-auto mb-6" />
          <p className="eyebrow mb-3">Our Story</p>
          <h1 className="section-title mb-6">About Magnolia Mold Co.</h1>
          <p className="font-serif text-2xl italic text-ink-soft leading-relaxed">
            Welcome to Magnolia Mold Earrings! We create unique, handcrafted earrings with love and attention to detail.
          </p>
        </div>
      </div>

      {/* Story */}
      <article className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-lg leading-relaxed text-ink-soft space-y-6">
        <p className="first-letter:float-left first-letter:font-serif first-letter:text-7xl first-letter:leading-[0.8] first-letter:text-sage-700 first-letter:mr-3 first-letter:mt-1">
          My name is Victoria, I’m 29 years old and currently a stay-at-home mom to two beautiful girls who keep me on my toes every day.
        </p>
        <p>
          Before starting Magnolia Mold Co, I worked in healthcare as a Certified Surgical Technologist. While my husband is currently in school for Respiratory Therapy, I wanted to find a creative outlet that would allow me to contribute financially while still being present for my family.
        </p>

        <blockquote className="border-l-2 border-gold-400 pl-6 my-10 font-serif text-2xl italic text-ink">
          It’s something that’s entirely mine, and I pour so much love and care into every pair of earrings I make.
        </blockquote>

        <p>
          Creating with polymer clay has become such a fulfilling and therapeutic hobby for me. It’s something that’s entirely mine, and I pour so much love and care into every pair of earrings I make. Each design is crafted with attention to detail and a desire to bring joy to those who wear them.
        </p>
        <p>
          Outside of making earrings, I’m passionate about weightlifting and recently started kickboxing. It’s been an amazing way to stay active and strong, both physically and mentally. I believe in the importance of self-care and finding activities that bring you joy and balance.
        </p>
        <p>
          Thank you so much for being here, supporting my small business, and cheering me on — it truly means more than you know 🤍 Every follow, share, and order helps support my family, and I’m so grateful for each of you.
        </p>
        <p className="font-script text-4xl text-sage-700 pt-2">
          Victoria
        </p>
      </article>

      {/* What makes us special */}
      <section className="bg-cream-50 border-y border-cream-300">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="text-center mb-12">
            <h2 className="section-title text-3xl md:text-4xl mb-4">What Makes Us Special</h2>
            <div className="flourish" aria-hidden="true">✦</div>
          </div>
          <ul className="grid sm:grid-cols-2 gap-4">
            {specials.map((item) => (
              <li key={item} className="flex items-start gap-3 bg-white border border-cream-300 rounded-xl p-5 text-ink">
                <span className="text-gold-500 mt-0.5" aria-hidden="true">✦</span>
                {item}
              </li>
            ))}
          </ul>
          <p className="text-center font-serif italic text-xl text-ink-soft mt-8">…and made with love.</p>
        </div>
      </section>

      {/* Visit Us */}
      <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
        <h2 className="section-title text-3xl md:text-4xl mb-4">Visit Us</h2>
        <p className="text-lg text-ink-soft mb-8">
          You can find our earrings at local markets and online. Follow us on social media to stay updated
          on new designs and where to find us next!
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/shop" className="btn-brand">Shop the Collection</Link>
          <a href="https://www.instagram.com/magnoliamoldco" target="_blank" rel="noopener noreferrer" className="btn-brand-outline">
            Follow on Instagram
          </a>
        </div>
      </section>
    </div>
  );
}
